const qs = require('query-string');

class URLSearchParamsPolyfill {
    // TODO remove URLSearchParamsPolyfill if we drop IE11 support
    constructor(search) {
        this.queryObj = qs.parse(search);
    }

    set(name, value) {
        this.queryObj[name] = value;
    }
    delete(name) {
        delete this.queryObj[name];
    }

    toString() {
        return qs.stringify(this.queryObj, {sort: false});
    }
}

const setQueryStringParameter = (name, value) => {
    if (typeof window === 'undefined' || !window.location || !window.history) {
        return;
    }

    const _URLSearchParams =
        typeof URLSearchParams === 'undefined' ? URLSearchParamsPolyfill : URLSearchParams;

    const params = new _URLSearchParams(window.location.search);

    if (!value) {
        params.delete(name);
    } else {
        params.set(name, value);
    }
    const queryString = `${decodeURIComponent(params)}`;
    const newURL = queryString
        ? `${window.location.pathname}?${queryString}`
        : window.location.pathname;
    window.history.replaceState({}, '', newURL);
};

module.exports = {
    URLSearchParamsPolyfill,
    setQueryStringParameter
};
